import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { StyledPopper } from './StyledComponents'; // Import styled components from a separate file
import AutocompleteComponent from './AutocompleteComponent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Box, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface Company {
	Id: string;
	Name: string;
}

interface FloatingCompanySelectorProps {
	onUpdate: (company: Company | null) => void;
	companies: Company[];
	loadingCompanies: boolean;
}

export default function FloatingCompanySelector(
	props: FloatingCompanySelectorProps,
) {
	const { onUpdate, companies, loadingCompanies } = props;
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const theme = useTheme();

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
		anchorEl?.focus();
	};

	const handleSelectionChange = (newValue: Company | null) => {
		onUpdate(newValue?.Id ? newValue : null);
		handleClose();
	};

	const open = Boolean(anchorEl);
	const id = open ? 'employee-label' : undefined;

	return (
		<Box>
			<IconButton aria-describedby={id} onClick={handleClick}>
				<ArrowDropDownIcon />
			</IconButton>
			<StyledPopper
				id={id}
				open={open}
				anchorEl={anchorEl}
				placement="bottom-start"
			>
				<ClickAwayListener onClickAway={handleClose}>
					<div>
						<AutocompleteComponent
							value={null}
							onValueChange={handleSelectionChange}
							handleClose={handleClose}
							options={companies}
							optionLabelAttribute="Name"
							loadingOptions={loadingCompanies}
							theme={theme}
						/>
					</div>
				</ClickAwayListener>
			</StyledPopper>
		</Box>
	);
}
